export const colors = [
  '#7BC86C',
  '#F5DD29',
  '#FFAF3F',
  '#EF7564',
  '#CD8DE5',
  '#5BA4CF',
  '#29CCE5',
  '#6DECA9',
  '#FF8ED4',
  '#172B4D',
];
